import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/serviceBase';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuditDetailsModel } from '../models/audit-details-model';
import { AuditListModel } from '../models/audit-list.model';
import { AuditAddModel } from '../models/audit-add-model';
import { AuditTypeModel } from '../models/audit-type.model';
import { AuditModuleListModel } from '../models/audit-module-list.model';
import { ModuleModel } from '../models/module.model';
import { AuditModuleAddModel } from '../models/audit-module-add.model';
import { AuditTypeAddModel } from '../models/audit-type-add-model';

@Injectable()
export class AuditService extends ServiceBase {
    private commonUrl: string = this.url + '/Audit/';
    constructor(
        private _http: HttpClient,
        private _authentication: AuthenticationService
    ) {
        super();
    }

    create(model: AuditAddModel): Observable<string> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    update(model: AuditDetailsModel): Observable<Response> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .put(completeUrl, model).pipe(
                map((response: Response) => response),
                catchError(this.handleError));
    }

    getAll(): Observable<AuditListModel[]> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .get<AuditListModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    get(id: string): Observable<AuditDetailsModel> {
        const completeUrl: string = this.commonUrl + id;
        return this._http
            .get<AuditDetailsModel>(completeUrl).pipe(
                catchError(this.handleError));
    }

    createAuditType(model: AuditTypeAddModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'audit-type';
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    getAuditTypes(): Observable<AuditTypeModel[]> {
        const completeUrl: string = this.commonUrl + 'audit-types';
        return this._http
            .get<AuditTypeModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getAuditModules(auditId: string): Observable<AuditModuleListModel[]> {
        const completeUrl: string = this.commonUrl + 'audit-modules/' + auditId;
        return this._http
            .get<AuditModuleListModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getModules(): Observable<ModuleModel[]> {
        const completeUrl: string = this.commonUrl + 'modules';
        return this._http
            .get<ModuleModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    addModuleToAudit(model: AuditModuleAddModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'add-module';
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    deleteAuditModule(auditId: string, moduleId: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + 'delete-audit-module/' + auditId + '/' + moduleId;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }
}
